export const overlapTriggerOffset = ({ rects }: { rects: { reference: { height: number } } }): number =>
  -rects.reference.height;
